import React from 'react'
import TimeDifference from '../../../common/TimeDifference';
import { Tooltip } from 'react-tooltip';

function ContactList({users, handleUserSelect, selectedUser, lastPage, handleLoadMore}) {

    function formatPhoneNumber(phoneNumberString) {
        const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return phoneNumberString;
    }
  
    function handleTrim(str, len) {
        if (!str) return '';
        return str.length > len ? str.substring(0, len) + '...' : str;
    }

    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.trim().split(' ');
        if (parts.length >= 2) {
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }
        return name.trim().charAt(0).toUpperCase();
    };

    const getAvatarStyle = (name) => {
        const colors = [
            { bg: '#e8f4fd', text: '#0d6efd' },  // primary
            { bg: '#d1f2eb', text: '#198754' },  // success
            { bg: '#cff4fc', text: '#0dcaf0' },  // info
            { bg: '#fff3cd', text: '#ffc107' },  // warning
            { bg: '#f8d7da', text: '#dc3545' },  // danger
        ];
        const index = name ? name.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };
  
    return (
        <div className="contact-list-container" style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
            {users && users.length === 0 ? (
                <div className="text-center py-5">
                    <i className="bi bi-inbox text-muted" style={{fontSize: '2rem'}}></i>
                    <p className="text-muted mt-2 mb-0">No conversations found</p>
                </div>
            ) : (
                <div className="list-group list-group-flush">
                    {users && users.map((user) => {
                        const isSelected = selectedUser && selectedUser === user.customerNumber;
                        const avatarStyle = getAvatarStyle(user.customerNames);
                        
                        return (
                            <div 
                                className="list-group-item list-group-item-action border-0 rounded mb-1 p-3"
                                key={user.customerNumber} 
                                onClick={() => handleUserSelect(user.customerNumber)}
                                style={{ 
                                    cursor: 'pointer', 
                                    transition: 'all 0.2s ease',
                                    backgroundColor: isSelected ? '#e8f4fd' : 'transparent',
                                    borderLeft: isSelected ? '3px solid #0d6efd' : '3px solid transparent'
                                }}
                                data-tooltip-id="fullUserName"
                                data-tooltip-content={user.customerNames}
                                data-tooltip-place="right"
                            >
                                <div className="d-flex align-items-start">
                                    {/* Avatar */}
                                    <div className="position-relative me-3">
                                        <div 
                                            className="d-flex align-items-center justify-content-center rounded-circle"
                                            style={{
                                                width: '48px', 
                                                height: '48px',
                                                backgroundColor: avatarStyle.bg
                                            }}
                                        >
                                            <span className="fw-bold" style={{ color: avatarStyle.text }}>
                                                {getInitials(user.customerNames)}
                                            </span>
                                        </div>
                                        {user.unreadMessage > 0 && (
                                            <span 
                                                className="position-absolute badge rounded-pill bg-danger"
                                                style={{
                                                    fontSize: '0.65rem',
                                                    top: '-5px',
                                                    right: '-5px'
                                                }}
                                            >
                                                {user.unreadMessage > 9 ? '9+' : user.unreadMessage}
                                            </span>
                                        )}
                                    </div>

                                    {/* Content */}
                                    <div className="flex-fill" style={{ minWidth: 0 }}>
                                        <div className="d-flex justify-content-between align-items-start mb-1">
                                            <h6 className={`mb-0 text-truncate ${user.unreadMessage > 0 ? 'fw-bold' : 'fw-semibold'}`} style={{ color: '#212529' }}>
                                                {handleTrim(user.customerNames, 25)}
                                            </h6>
                                            <small className="text-muted ms-2" style={{ flexShrink: 0 }}>
                                                <TimeDifference dateString={user.createdAt} />
                                            </small>
                                        </div>
                                        <div className="small text-muted mb-1">
                                            <i className="bi bi-telephone me-1"></i>
                                            {formatPhoneNumber(user.customerNumber)}
                                        </div>
                                        <p className={`mb-0 small text-truncate ${user.unreadMessage > 0 ? '' : 'text-muted'}`} style={{ color: user.unreadMessage > 0 ? '#495057' : undefined }}>
                                            {handleTrim(user.lastMessage, 35)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
           
            {!lastPage && users && users.length > 0 && (
                <div className="text-center py-3">
                    <button 
                        className="btn btn-outline-primary btn-sm rounded-pill px-4" 
                        onClick={handleLoadMore}
                    >
                        <i className="bi bi-arrow-down-circle me-2"></i>
                        Load More
                    </button>
                </div>
            )}
            <Tooltip id="fullUserName" style={{ zIndex: 9999 }} />

            <style>{`
                .contact-list-container::-webkit-scrollbar {
                    width: 4px;
                }
                .contact-list-container::-webkit-scrollbar-track {
                    background: transparent;
                }
                .contact-list-container::-webkit-scrollbar-thumb {
                    background: #dee2e6;
                    border-radius: 4px;
                }
                .contact-list-container::-webkit-scrollbar-thumb:hover {
                    background: #adb5bd;
                }
                .hover-bg-light:hover {
                    background-color: #f8f9fa !important;
                }
                .min-width-0 {
                    min-width: 0;
                }
            `}</style>
        </div>
    )
}

export default ContactList